module.exports = __webpack_public_path__ + "img/az.67b7d76f.svg";